var map = {
	"./1893/ship.svg": "4cd2",
	"./1925/ship.svg": "2a54",
	"./1949/ship.svg": "6f80",
	"./1951/ship.svg": "7e41",
	"./1954/ship.svg": "dce2",
	"./1960/ship.svg": "db85",
	"./1982/ship.svg": "d7c2",
	"./1993/ship.svg": "3245",
	"./2016/ship.svg": "ee5d",
	"./originals/1893/ship.svg": "6c69",
	"./originals/1925/ship.svg": "149e",
	"./originals/1949/ship.svg": "380d",
	"./originals/1951/ship.svg": "0274",
	"./originals/1954/ship.svg": "4b16",
	"./originals/1960/ship.svg": "6530",
	"./originals/1982/ship.svg": "d43b",
	"./originals/1993/ship.svg": "3df7",
	"./originals/2016/ship.svg": "8192"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e0b6";